const axios = require('axios')

const methods = ['get', 'post', 'put', 'delete']

export default class Request {
  constructor() {
    this.axios = axios
    this.promiseHandlers = []

    methods.forEach(method => {
      this[method] = (...args) => {
        return this.chainPromiseHandlers(this.axios[method](...args))
      }
    })
  }

  addPromiseHandler(handler) {
    this.promiseHandlers.push(handler)
  }

  chainPromiseHandlers(promise) {
    return this.promiseHandlers.reduce((promise, handler) => handler(promise), promise)
  }
}


// WEBPACK FOOTER //
// ./services/request.js